import ManageProducerTable from './ManageProducerTable'

const ManageProducer = {
  Table: ManageProducerTable,
}

export default ManageProducer
